import axios from 'axios';
import { app } from '../main';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueGtag from 'vue-gtag-next';

let recaptchaPromise = null;
let recaptchaRegistrado = false;

const appModule = {
    state() {
        return {
            menuVisible: true,
        };
    },

    mutations: {
        carregar() {
            axios.get('app/analytics.txt').then((res) => {
                app.use(VueGtag, {
                    property: {
                        id: res.data,
                    },
                });
            });
        },

        trocarMenu(state) {
            state.menuVisible = !state.menuVisible;
        },
    },

    actions: {
        async carregarConfigApp({ commit }) {
            commit('carregar');

            if (recaptchaRegistrado) {
                return null;
            }

            if (!recaptchaPromise) {
                recaptchaPromise = axios
                    .get('app/recaptcha.txt')
                    .then((res) => {
                        if (!recaptchaRegistrado) {
                            app.use(VueReCaptcha, {
                                siteKey: res.data.trim(),
                                loaderOptions: {
                                    useRecaptchaNet: true,
                                    autoHideBadge: true,
                                },
                            });
                            recaptchaRegistrado = true;
                        }
                    })
                    .finally(() => {
                        recaptchaPromise = null;
                    });
            }

            return recaptchaPromise;
        },

        async verificarVersao() {
            await axios
                .get('app/versao.txt', {
                    // Timestamp na query fura cache de navegador e de proxies que ignoram headers
                    params: { t: Date.now() },
                    headers: {
                        'Cache-Control': 'no-cache',
                    },
                })
                .then((res) => {
                    let versaoLida = String(res.data).replace(/[^a-zA-Z0-9.-]/g, '');
                    if (!versaoLida || process.env.VUE_APP_VERSION == versaoLida) {
                        return;
                    }
                    // Se já recarregamos para esta versão e o bundle continua antigo,
                    // é um cache intermediário teimoso — não entrar em loop de reload
                    if (sessionStorage.getItem('portalReloadVersao') === versaoLida) {
                        return;
                    }
                    sessionStorage.setItem('portalReloadVersao', versaoLida);
                    // Query string nova força buscar o index.html fresco mesmo com
                    // cache heurístico/proxy (reload() simples pode servir o antigo)
                    window.location.href = `${window.location.pathname}?v=${versaoLida}${window.location.hash}`;
                })
                .catch(() => {
                    // Falha ao ler versao.txt não pode derrubar o boot do app
                });
        },

        trocarMenu({ commit }) {
            commit('trocarMenu');
        },
    },

    getters: {
        menuVisible(state) {
            return state.menuVisible;
        },
    },
};

export default appModule;
